import { Reducer } from 'redux'

import { ActionTypes as CreateCitation } from '../createCitation/constants'
import { Action } from '../createCitation/types'
import { ErrorState } from './types'
import * as ActionTypes from './constants'
import { displayError, clearSearchResultsError } from './actions'

export const initialState: ErrorState = ''

export const errorReducer: Reducer<
  ErrorState,
  Action | ReturnType<typeof displayError | typeof clearSearchResultsError>
> = (state = initialState, action) => {
  switch (action.type) {
    case CreateCitation.CREATE_CITATION_SEARCH_FAILED:
    case ActionTypes.ERROR_DISPLAY:
      return action.payload.message
    case CreateCitation.CREATE_CITATION_JOURNAL_TAB_SELECTED:
    case CreateCitation.CREATE_CITATION_SEARCH_RESULTS_PAGE_LOADED:
    case ActionTypes.CLEAR_SEARCH_RESULTS_ERROR:
      return initialState
    default:
      return state
  }
}

export default errorReducer
